<template>
  <section>
    <SideLeft
      :status="leftSideStatus"
      :fCodeFilter="fCodeFilter"
      :fFilterSku="fFilterSku"
      :fCodeinvoicesFilter="fCodeinvoicesFilter"
      :fTimeCreatedFrom="fTimeCreatedFrom"
      :fTimeCreatedTo="fTimeCreatedTo"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :checkArrs="checkArrs"
        :fCodeFilter="fCodeFilter"
        :fFilterSku="fFilterSku"
        :fCodeinvoicesFilter="fCodeinvoicesFilter"
        :fTimeCreatedFrom="fTimeCreatedFrom"
        :fTimeCreatedTo="fTimeCreatedTo"
        @clearKey="clearKey"
        @exportList="exportList"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        :checkArrs="checkArrs"
      ></router-view>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/invoices/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <api-loading :show="loading"></api-loading>
  </section>
</template>

<script>
import { pagination } from "@components/pagination.js"; //分页
import SideLeft from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //页面头部
export default {
  components: {
    SideLeft,
    Header,
    Pagination: pagination,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("deposit-rowsPerPage"))
        ? parseInt(store.get("deposit-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      checkArrs: [],
      fCodeFilter: "",
      fFilterSku: "",
      fCodeinvoicesFilter: "",
      fTimeCreatedFrom: "",
      fTimeCreatedTo: "",
    };
  },
  watch: {
    $route: "gotoPage",
  },
  mounted() {
    let that = this;
    //展开折叠搜索
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "order.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("order.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("order.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
    this.getList();
  },
  methods: {
    /**
     * 获取列表数据
     */
    getList() {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        timeCreatedFrom: this.fTimeCreatedFrom,
        timeCreatedTo: this.fTimeCreatedTo,
      };
      if (this.fCodeFilter) {
        params.code = this.fCodeFilter;
      }
      if (this.fFilterSku) {
        params.codeErp = this.fFilterSku;
      }
      if (this.fCodeinvoicesFilter) {
        params.invoiceNumber = this.fCodeinvoicesFilter;
      }
      $.api_call("api.Invoice.findBySupplier", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    /**
     * 根据选择跳转到第几页
     */
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ params: { page: 1 } });
      if (page == 1) {
        this.getList();
      }
    },
    /**
     * 跳转到第几页
     */
    toPage(num) {
      let page = this.page;
      this.$router.push({ params: { page: num } });
      if (page == num) {
        this.getList();
      }
    },
    /**
     * 监听路由事件
     */
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
    },
    /**
     * 筛选事件
     */
    filtrate(
      code,
      filterSku,
      codeinvoicesFilter,
      timeCreatedFrom,
      timeCreatedTo
    ) {
      this.fCodeFilter = code;
      this.fFilterSku = filterSku;
      this.fCodeinvoicesFilter = codeinvoicesFilter;
      this.fTimeCreatedFrom = timeCreatedFrom;
      this.fTimeCreatedTo = timeCreatedTo;

      //筛选都回第一页
      this.toPage(1);
    },
    /**
     * 关闭header组件的筛选信息
     */
    clearKey(type) {
      switch (type) {
        case "fCodeFilter":
          this.fCodeFilter = "";
          break;
        case "fFilterSku":
          this.fFilterSku = "";
          break;
        case "fCodeinvoicesFilter":
          this.fCodeinvoicesFilter = "";
          break;
        case "timefilter":
          this.fTimeCreatedFrom = "";
          this.fTimeCreatedTo = "";
          break;
      }
      this.toPage(1);
    },
    /**
     * 导出发票信息
     */
    exportList() {
      if (this.checkArrs.length == 0) {
        ShowTip(this.$t("order.请选择发票"), "danger");
        return;
      }
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      this.loading = true;
      $.api_call(
        "api.Invoice.downloadInvoiceList",
        {
          ids: this.checkArrs.join(","),
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            document.getElementById("ifile").src = r.Data.Results.url;
            this.checkArrs = [];
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>
